import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Subject } from 'rxjs';
export const credentialsKey = 'currentUser';

@Injectable()
export class CredentialsService {
  private _credentials: any | null;
  public onUserAuth =  new Subject<boolean>();
constructor(
    // private localStorage : LocalStorageService,
    // private sessionStorage : SessionStorageService
){
  const savedCredentials = localStorage.getItem('currentUser');
  if (savedCredentials) {
    this._credentials = JSON.parse(savedCredentials).toString();
    
    this.onUserAuth.next(true);
  } else {
    this.onUserAuth.next(false);
  }
}

  /**
   * Checks is the user is authenticated.
   * @return {boolean} True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    return !!this.credentials;
  }

  /**
   * Gets the user credentials.
   * @return {Credentials} The user credentials or null if the user is not authenticated.
   */
  get credentials(): any | null {
    return this._credentials;
  }
  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param {Credentials=} credentials The user credentials.
   * @param {boolean=} remember True to remember credentials across sessions.
   */
  public async setCredentials(credentials?: any) {
    this._credentials = credentials || null;
    if (credentials) {
        localStorage.setItem(credentialsKey, JSON.stringify(credentials).toString());
        sessionStorage.setItem(credentialsKey, JSON.stringify(credentials).toString());
        this.onUserAuth.next(true);
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
      this.onUserAuth.next(false);
    }
  }

  public getUser() {
    const savedCredentials = localStorage.getItem('currentUser') || sessionStorage.getItem('currentUser') ;
    return savedCredentials ? JSON.parse(savedCredentials) : null;
  }

}